import { Button, Flex, Table } from "antd";
import { SearchOutlined, CloseCircleOutlined } from "@ant-design/icons";
import styles from "../../Assets/taskCoworkerFilter.module.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchActiveUsers } from "../../../redux/actions/action";
import { AddUserToGroupChatWidget } from "../../../redux/actions/chatActions";

function CoWorkerModal({ modalOpen, modalHideEv, groupId, groupUsers }) {
  const dispatch = useDispatch();
  const [searchItems, setSearchItems] = useState("");
  const [stockData, setStockData] = useState([]);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");

  const activeStatusResponse = useSelector(
    (state) => state.user.activeStatusResponse
  );

  useEffect(() => {
    if (companyId) {
      dispatch(FetchActiveUsers(companyId));
    }
  }, [dispatch, companyId]);

  useEffect(() => {
    if (activeStatusResponse?.status) {
      const updatedStockData = activeStatusResponse?.data.map((item) => {
        const isUserInGroup = groupUsers.some(
          (groupUser) => groupUser.userid === item.userid
        );
        return {
          ...item,
          isChecked: isUserInGroup,
          isDisabled: isUserInGroup, // Disable if the user is in groupUsers
        };
      });
      setStockData(updatedStockData);
    }
  }, [activeStatusResponse, groupUsers]);

  const handleCheckboxChange = (e, record) => {
    const updatedStockData = stockData.map((item) => {
      if (item.userid === record.userid) {
        return { ...item, isChecked: e.target.checked };
      }
      return item;
    });

    setStockData(updatedStockData);
    if (e.target.checked) {
      setSelectedUser(record);
      setIsConfirmModalVisible(true);
    }
  };

  const handleConfirmYes = () => {
    let reqArray = [];
    reqArray.push({
      userid: selectedUser.userid,
    });
    if (reqArray) {
      dispatch(AddUserToGroupChatWidget(groupId, userId, reqArray));
    }
    setIsConfirmModalVisible(false);
    modalHideEv(false); // Close the main modal
  };

  const handleConfirmNo = () => {
    const updatedStockData = stockData.map((item) => {
      if (item.userid === selectedUser.userid && !item.isDisabled) {
        return { ...item, isChecked: false };
      }
      return item;
    });

    setStockData(updatedStockData);
    setSelectedUser(null);
    setIsConfirmModalVisible(false);
  };

  const getFilteredData = () =>
    stockData.filter((item) =>
      item.firstname?.toLowerCase().includes(searchItems.toLowerCase())
    );

  const partTableColumn = [
    {
      title: "",
      dataIndex: "userid",
      key: "userid",
      render: (text, record) => (
        <div className="custom-checkbox-wrap">
          <input
            type="checkbox"
            id={`checkbox_${record.userid}`}
            checked={record.isChecked}
            onChange={(e) => handleCheckboxChange(e, record)}
            disabled={record.isDisabled} // Disable the checkbox if needed
            style={{ cursor: record.isDisabled ? "not-allowed" : "pointer" }}
          />
          <span className="checkmark"></span>
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "firstname",
      key: "firstname",
      render: (text, record) => (
        <div className={styles.icon_text}>
          <div className={styles.icon_wrap}>
            {record.imageurl ? (
              <img src={record.imageurl} alt="" />
            ) : (
              <div
                style={{
                  backgroundColor: "#95A7C6",
                  color: "#ffffff",
                  width: "25px",
                  height: "25px",
                  borderRadius: "50%",
                  border: "2px solid var(--unnamed-color-00246a)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {record.firstname?.[0]?.toUpperCase()}
              </div>
            )}
          </div>
          {record.firstname} {record.lastname}
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "jobtypename",
      key: "jobtypename",
      render: (text) => <div className={styles.icon_text}>{text ?? "-"}</div>,
    },
  ];

  return (
    <>
      <div
        className={`${styles.addPartPopupChat} ${modalOpen ? styles.show : ""}`}
        style={{ maxWidth: "564px" }}
      >
        <div className={styles.part_popup_inner}>
          <div className={styles.part_popup_header}>
            <div className={styles.title_wrap}>
              <Flex gap="small" className={styles.flex}>
                <div
                  className="kanban-calendar-joint"
                  style={{ border: "none", minWidth: "0" }}
                >
                  <p
                    className="mb-0 co-worker-title"
                    style={{
                      fontSize: "clamp(16px,0.9vw,0.9vw)",
                      color: "black",
                      border: "none",
                    }}
                  >
                    Co-Workers
                  </p>
                </div>
                <div className="search_input-chat">
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={(e) => setSearchItems(e.target.value)}
                  />
                  {!searchItems.length > 0 && (
                    <Button
                      type="text"
                      shape="circle"
                      icon={<SearchOutlined />}
                    />
                  )}
                </div>
              </Flex>
            </div>
            <div className={styles.close_btn_wrap}>
              <Button
                type="text"
                shape="circle"
                icon={<CloseCircleOutlined />}
                onClick={() => modalHideEv(!modalOpen)}
              />
            </div>
          </div>
          <div className={styles.popup_body}>
            <div
              className={`${styles.table_wrapper} part-table-wrapper`}
              style={{ fontWeight: "400" }}
            >
              <Table columns={partTableColumn} dataSource={getFilteredData()} />
            </div>
          </div>
        </div>

        {isConfirmModalVisible && (
          <div
            className={`${styles.confirmCoWorkerModal} ${
              isConfirmModalVisible ? styles.show : ""
            }`}
          >
            <span>Would you like to turn the Co-worker into an Agent?</span>
            <div className="co-worker-modal-btn">
              <button
                className="task-modal-cancel-btn-pop2 ms-auto"
                onClick={handleConfirmNo}
                style={{ fontSize: "14px", fontWeight: "bold" }}
              >
                Cancel
              </button>
              <button
                className="m-0 task-modal-cancel-btn1-pop me-3"
                onClick={handleConfirmYes}
                style={{ fontSize: "14px", fontWeight: "bold" }}
              >
                Yes
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default CoWorkerModal;
